import { render, staticRenderFns } from "./AddressRelbaseInline.vue?vue&type=template&id=67271757&"
import script from "./AddressRelbaseInline.vue?vue&type=script&lang=js&"
export * from "./AddressRelbaseInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports